import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function EditCategories({recipeId, setCategoryIds}) {

    const [categories, setCategories] = useState([])

    useEffect(() => {

        if (categories) {
            const categoryIds = categories.map(category => {
                return category.category_id
            })
            setCategoryIds(categoryIds)
        }

    }, [categories])

    useEffect(() => {

        try {
            const categoriesRef = firestore.collection("recipes").doc(recipeId).collection("categories")
            categoriesRef.onSnapshot(({docs}) => {
                const categories = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setCategories(categories)
            })
        } catch (error) {
            console.log(error)
        }

    }, [recipeId])

    async function deleteHandler(e, categoryId) {
        try {
            const categoriesRef = firestore.collection("recipes").doc(recipeId).collection("categories").doc(categoryId)
            categoriesRef.delete()
        } catch (error) {
            
        }
    }

    return (
        <div>
            {categories && categories.map((category, index) => {
                return (
                    <div key={index} className="col-md-6">
                        {category.category} <span onClick={e => deleteHandler(e, category.id)} className="float-right"><i className="fas fa-trash text-danger"></i></span>
                    </div>
                )
            })}
        </div>
    )
}
export default EditCategories